// ============================================================
// Coverage tinting — the % of questions answered per checkpoint
//
// Per Bryan: red 0-25%, orange 26-50%, yellow 51-75%, light green 76-99%,
// full green 100%. The eye should land on red/orange/yellow first, before
// green. Coverage is NOT deal-health — it only reflects how much intel the
// rep has gathered for that checkpoint.
// ============================================================

export type CoverageTint = "red" | "orange" | "yellow" | "lightgreen" | "green" | "empty";

export function coverageTint(answered: number, total: number): CoverageTint {
  if (total === 0) return "empty";
  const pct = (answered / total) * 100;
  if (pct === 0) return "red";
  if (pct <= 25) return "red";
  if (pct <= 50) return "orange";
  if (pct <= 75) return "yellow";
  if (pct < 100) return "lightgreen";
  return "green";
}

export const COVERAGE_STYLES: Record<CoverageTint, {
  bg: string;
  border: string;
  text: string;
  bar: string;
  label: string;
}> = {
  red: {
    bg: "bg-rose-50",
    border: "border-rose-200",
    text: "text-rose-800",
    bar: "bg-rose-400",
    label: "0-25% answered",
  },
  orange: {
    bg: "bg-orange-50",
    border: "border-orange-200",
    text: "text-yellow-800",
    bar: "bg-orange-500",
    label: "26-50% answered",
  },
  yellow: {
    bg: "bg-orange-50",
    border: "border-orange-200",
    text: "text-yellow-800",
    bar: "bg-orange-400",
    label: "51-75% answered",
  },
  lightgreen: {
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    text: "text-emerald-800",
    bar: "bg-emerald-300",
    label: "76-99% answered",
  },
  green: {
    bg: "bg-emerald-100",
    border: "border-emerald-300",
    text: "text-emerald-900",
    bar: "bg-emerald-500",
    label: "100% answered",
  },
  empty: {
    bg: "bg-[hsl(var(--surface-2))]",
    border: "border-border",
    text: "text-muted-foreground",
    bar: "bg-muted",
    label: "no questions",
  },
};
